<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <townName ref="townlist" v-on:townadcd="townAdcd"></townName>
      <div class="yuliang" ref="yuliang">
        <div class="select">
          <!-- 水库类型 -->
          <div class="reservoirType" >
                <span class="desc">水库类型：</span>
                  <el-select
                    v-model="reservoirType"
                    placeholder="请选择水库类型"
                    clearable
                  >
                    <el-option
                      v-for="item in optionsType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                </el-select>
          </div>
          <!-- 类别 -->
          <!-- <div class="storageType" >
                <span class="desc">类别：</span>
                <div>
                   <el-select
                    v-model="storageType"
                    placeholder="请选择类别"
                    clearable
                  >
                    <el-option
                      v-for="item in Type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                </el-select>
                </div>
          </div> -->
          <!-- 时间 -->
              <!-- <span class="desc">日期:</span>
              <el-date-picker
                v-model="seletdate"
                value-format="yyyy-MM-dd hh-mm"
                type="datetime"
                placeholder="选择日期"
              ></el-date-picker> -->
              <span class="desc">站名:</span>
              <el-input @change="nameSelect" v-model="inputData" clearable placeholder="请输入站名"></el-input>
              <div class="time" style="display: inline-block;">
                <span class="desc">时间:</span>
                <div style="display: inline-block;">
                  <el-date-picker
                    v-model="seletdate"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    type="datetime"
                    placeholder="选择开始时间"
                    default-time="08:00:00"
                    clearable
                    :editable="false"
                    @change="searchData"
                  ></el-date-picker>
                </div>
              <span id="select" @click="searchData">查询</span>
           </div>
          <!-- <div>
            <span class="desc">站名:</span>
            <el-input @change="nameSelect" v-model="inputData" clearable placeholder="请输入站名"></el-input>
            <span id="select" @click="searchData">查询</span>
          </div> -->
          <div class="export">
             <span @click="exportdata" id="export"><span class="export-icon"></span>导出</span>
          </div>
        </div>
        <div class="raintable">
          <el-table v-loading="loading" :row-class-name="tableRowClassName" :data="tdata" :height="height" border style="width: 100%;">
            <el-table-column fixed type="index" width="60" label="序号" align="center" header-align="center">
            </el-table-column>
            <el-table-column fixed prop="addvnm" align="center" header-align="center" label="乡镇" sortable min-width="100">
            </el-table-column>
            <el-table-column fixed prop="stnm" align="center" header-align="center" label="站名" sortable min-width="150">
              <template slot-scope="scope">
                <!-- <span
                  @click="stationchart(scope.row)"
                  style="cursor:pointer!important;font-weight:bold"
                  >{{ scope.row.stnm }}</span
                > -->
                <el-tooltip effect="dark" :content="scope.row.stnm + ' ' + (scope.row.stcd?scope.row.stcd:'')" placement="top" class="item" popper-class="hiddenOverflow">
                  <span @click="stationchart(scope.row)" style="cursor:pointer!important;font-weight:bold">{{ scope.row.stationName }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="waterAtEight_Str" align="center" header-align="center" label="8时水位@（m）" :render-header="renderheader" min-width="90" :sortable='true' :sort-method="sortChange1">
              <template slot-scope="scope">
                <div style="width:100%;text-align: left;" v-if="/.*[\u4e00-\u9fa5]+.*$/.test(scope.row.waterAtEight_Str)">{{ scope.row.waterAtEight_Str }}</div>
                <div v-else>{{ scope.row.waterAtEight_Str }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="time" align="center" header-align="center" label="当前水位时间" min-width="130" sortable>
              <template slot-scope="scope">
              <span :style="new Date(scope.row.time) <  timecompare? 'color:red;':''" v-if="scope.row.time !== undefined && scope.row.time !== null">{{scope.row.time.slice(5,16)}}</span>
              <span v-else>-</span>
            </template>
            </el-table-column>
            <el-table-column prop="water_Str" align="center" header-align="center" label="当前水位@（m）" :render-header="renderheader" min-width="90" :sortable='true' :sort-method="sortChange2">
              <template slot-scope="scope">
                <div style="width:100%;text-align: left;" v-if="/.*[\u4e00-\u9fa5]+.*$/.test(scope.row.water_Str)">{{ scope.row.water_Str }}</div>
                <div v-else>{{ scope.row.water_Str }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="warningWater_Str" align="center" header-align="center" label="汛限水位@（m）" :render-header="renderheader" min-width="90" :sortable='true' :sort-method="sortChange3">
            </el-table-column>
            <el-table-column prop="overflowWarningWater_Str" align="center" header-align="center" label="超汛限水位@（m）" :render-header="renderheader" min-width="100" :sortable='true' :sort-method="sortMethod1">
              <template slot-scope="scope">
                <font v-if="scope.row.overflowWarningWater_Str > 0" color="red">{{scope.row.overflowWarningWater_Str}}</font>
                <font v-else>{{scope.row.overflowWarningWater_Str}}</font>
              </template>
            </el-table-column>
            <el-table-column prop="warningWaterStorage" align="center" label="汛限库容@（万m³）" min-width="90" :render-header="renderheader">
            </el-table-column>
            <el-table-column prop="rainfallArea" align="center" header-align="center" label="集雨面积@（km²）" min-width="90" sortable :render-header="renderheader">
            </el-table-column>
            <el-table-column prop="storeLevel" align="center" label="正常水位@（m）" min-width="90" :render-header="renderheader">
            </el-table-column>
            <el-table-column prop="normalStorage" align="center" label="正常库容@（万m³）" min-width="90" :render-header="renderheader">
            </el-table-column>
            <el-table-column prop="ssw" align="center" label="死水位@（m）" min-width="70" :render-header="renderheader">
            </el-table-column>
            <el-table-column prop="skr" align="center" label="死库容@(万m³)" min-width="70" :render-header="renderheader">
            </el-table-column>
            <el-table-column prop="waterStorage"  align="center" label="当前库容@（万m³）" min-width="100" :render-header="renderheader">
            </el-table-column>
             <el-table-column prop="impoundmentRate" align="center" label="蓄水率@（%）" min-width="70" :render-header="renderheader">
            </el-table-column>
            <el-table-column prop="klkr" align="center" label="可拦库容@（万m³）" min-width="90" :render-header="renderheader">
            </el-table-column>
            <el-table-column prop="ktjkr" align="center" label="可调节库容@（万m³）" min-width="100" :render-header="renderheader">
            </el-table-column>
            <!-- <el-table-column prop="netRainfall" align="center" label="可拦蓄雨量@（mm）" min-width="100" :render-header="renderheader">
            </el-table-column> -->
          </el-table>
          <div class="totalData">
            <div>{{totalData.totalWaterStorage}}</div>
            <div>{{totalData.totalImpoundmentRate}}</div>
            <div>{{totalData.totalKTJKR}}</div>
          </div>
        </div>
      </div>
    </div>
    <stationDialog ref="stationDialog"></stationDialog>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
import townName from '@/components/Townname'
import stationDialog from '@/components/stationDialog'
import timer from '@/utils/timer'
export default {
  name: 'MonitoringCenter',
  components: {
    townName, stationDialog
  },
  data () {
    return {
      maxZ_Time: '',
      lastestZ: '',
      maxZ: '',
      thestation: '',
      inputData: '',
      loading: true,
      loading1: true,
      height: 10,
      aDDVCD: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      dialogVisible: false,
      sTID: '',
      time: '',
      chartwaterValues: [],
      chartxline: [],
      chartwrZs: [],
      chartrainValues: [],
      datev: '',
      radio: '1',
      dateselect: true,
      sID: 22,
      myChart: {},
      reservoirType: '',
      storageType: '',
      seletdate: '',
      selectdate1: '',
      totalData: {},
      // optionsType: [{
      //   value: 'smallone',
      //   label: '小一型水库'
      // }, {
      //   value: 'smalltwo',
      //   label: '小二型水库'
      // }, {
      //   value: 'large,middle',
      //   label: '大中型水库'
      // }],
      optionsType: [{
        value: 'small',
        label: '小型水库'
      }, {
        value: 'large,middle',
        label: '大中型水库'
      }, {
        value: 'gssk',
        label: '供水水库'
      }, {
        value: 'fcfdsk',
        label: '非纯发电水库'
      }],
      Type: [{
        value: '正常蓄水',
        label: '正常蓄水'
      }, {
        value: '梅汛蓄水',
        label: '梅汛蓄水'
      }, {
        value: '台汛蓄水',
        label: '台汛蓄水'
      }],
      timerFun: '',
      minWarning: 0,
      timecompare: new Date(new Date() - 1200000)
    }
  },
  computed: {
  },
  methods: {
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === this.tdata.length - 1) {
        if (columnIndex === 0 || columnIndex === 2 || columnIndex === 4) {
          // return [1, 6]
          return {
            rowspan: 0,
            colspan: 0
          }
        } else if (columnIndex === 3 || columnIndex === 5 || columnIndex === 1) {
          // return [1, 6]
          return {
            rowspan: 1,
            colspan: 6
          }
        }
      }
    },
    // 行政区划选择
    townAdcd: function (townAdcd) {
      this.loading = true
      this.aDDVCD = townAdcd
      this.tabledata()
    },
    // 表头换行
    renderheader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('@')[0]),
        h('br'),
        h('span', {}, column.label.split('@')[1])
      ])
    },
    // 列排序
    sortChange1 (a, b) {
      // return a.waterAtEight - b.waterAtEight
      let bsort = b.waterAtEight_Str === undefined ? -1 : Number(b.waterAtEight_Str)
      let asort = a.waterAtEight_Str === undefined ? -1 : Number(a.waterAtEight_Str)
      return bsort - asort
    },
    sortChange2 (a, b) {
      // return a.water - b.water
      let bsort = b.water_Str === undefined ? -1 : Number(b.water_Str)
      let asort = a.water_Str === undefined ? -1 : Number(a.water_Str)
      return bsort - asort
    },
    sortChange3 (a, b) {
      // return a.warningWater - b.warningWater
      let bsort = b.warningWater_Str === undefined ? -1 : Number(b.warningWater_Str)
      let asort = a.warningWater_Str === undefined ? -1 : Number(a.warningWater_Str)
      return bsort - asort
    },
    sortChange4 (a, b) {
      return a.overflowWarningWater - b.overflowWarningWater
    },
    sortMethod1 (a, b) {
      let bsort = b.overflowWarningWater === undefined ? this.minWarning - 1 : Number(b.overflowWarningWater)
      let asort = a.overflowWarningWater === undefined ? this.minWarning - 1 : Number(a.overflowWarningWater)
      return bsort - asort
    },
    stationchart (item) {
      this.$refs.stationDialog.showlog(item, '#2F4F4F')
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        return 'warning-row'
      }
      return ''
    },
    nameSelect () {
      this.stationName = this.inputData
      this.tabledata()
    },
    searchData () {
      this.stationName = this.inputData
      this.tabledata()
    },
    towndata () {
      let arr = []
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.total
        this.towns = data.results
        this.towns.forEach(item => {
          let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
          obj.adcd = item.adcd
          obj.adnm = item.adnm
          obj.id = item.id
          arr.push(obj)
        })
        this.towns = arr
      })
    },
    tabledata () {
      this.loading = true
      this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
        sID: this.sID,
        aDDVCD: this.aDDVCD,
        orderField: 'overflowWarningWater',
        stationName: this.stationName,
        reservoirScale: this.reservoirType,
        time: this.seletdate,
        mainStation: false
      }).then(data => {
        this.tdata = data.rows
        this.totalData = { totalWaterStorage: data.totalWaterStorage, totalImpoundmentRate: data.totalImpoundmentRate, totalKTJKR: data.totalKTJKR }
        // this.tdata.push({})
        // this.tdata.push({ stlc: data.totalWaterStorage, waterAtEight_Str: data.totalImpoundmentRate, water_Str: data.totalKTJKR })
        // this.dataSort('overflowWarningWater', this.tdata)
        // 河道水位超警戒排序,获取最小值
        let filterWaterData = this.tdata.filter(item => { // 过滤数组中undefined类型
          return item.overflowWarningWater !== undefined
        })
        let min = Math.min.apply(Math, filterWaterData.map(item => { return item.overflowWarningWater }))
        this.minWarning = min
        this.tdata = this.tdata.sort((a, b) => {
          let bsort = b.overflowWarningWater === undefined ? this.minWarning - 1 : Number(b.overflowWarningWater)
          let asort = a.overflowWarningWater === undefined ? this.minWarning - 1 : Number(a.overflowWarningWater)
          return bsort - asort
        })
        // 超汛限水库
        let overflowWarningWaterArr = this.tdata.filter(el => {
          return el.overflowWarningWater > 0
        })
        // 未超汛限水库
        let noneOverflowWarningWaterArr = this.tdata.filter(el => {
          return !el.overflowWarningWater || el.overflowWarningWater <= 0
        })
        // 乡镇首字母排序
        let sortAddvnmArr = this.firstLetterSort(noneOverflowWarningWaterArr)
        let tableData = overflowWarningWaterArr.concat(sortAddvnmArr) // 超汛限排前，后面排按乡镇首字母排序
        this.tdata = tableData
        this.loading = false
      })
    },
    // 乡镇首字母排序
    firstLetterSort(item) {
      let resultArray = item.sort(
        function compareFunction(a, b) {
          return a.addvnm.localeCompare(b.addvnm, 'zh')
        }
      )
      return resultArray
    },
    // 数据排序
    dataSort (type, sortData) {
      this.sortType = type
      sortData.sort(this.compare(type))
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val2 - val1
      }
    },
    exportdata () {
      this.$store.dispatch(monitorTypes.EXPORT_RESERVOIR_WATER, {
        aDDVCD: this.aDDVCD,
        stationName: this.stationName,
        mainStation: false,
        reservoirScale: this.reservoirType,
        time: this.seletdate
      }).then(data => {
        window.location.href = this.Global.basePath + data.data
        // window.location.href
      })
    }
  },
  mounted () {
    // let nowdate = new Date()
    // this.seletdate = this.$moment(nowdate).format('YYYY-MM-DD HH:00')
    this.towndata()
    this.tabledata()
    this.timerFun = setInterval(this.searchData, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20 - 48
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.monitor{
  .content{
    .yuliang{
      .select{
        display: flex;
        position: relative;
        .el-input{
          width: 165px;
        }
        .export {
          position: absolute;
          right: 0;
        }
        div.storageType{
          display: flex;
          div{
            width:180px;
          }
        }
        div.reservoirType{
          display: flex;
          div{
            width:180px;
          }
        }
         div.time{
          div{
            width:220px;
          }
        }
      }
    }
  }
}
// 样式穿透
.content /deep/ .yuliang .raintable .el-table .warning-row{
  background:#f3f364 !important;
}
.raintable {
  .totalData{
    display: flex;
    justify-content: space-around;
    height: 48px;
    background: rgb(234,241,250);
    div{
      line-height: 48px;
    }
  }
}
#station{
  width: 100%;
  height: 400px;
}
.block{
  position: absolute;
  width: 95%;
  top: 15px;
  left: 0;
  text-align: center;
}
.chartshuiwei{
    text-align: center;
    width: 100%;
    // text-align: center;
  }
</style>
